<template>
    <div id="map-container">
        <div class="map-title">Mapa</div>
        <div class="map-menu">
            <div class="active" v-on:click="switchMode(0)">
                <img src="../../assets/app-icons/map/map.svg" />
                <span>Mapa</span>
            </div>
            <div v-on:click="switchMode(1)">
                <img src="../../assets/app-icons/map/list.svg" />
                <span>Lista</span>
            </div>
        </div>
        <div class="real-map">
            <svg x="0" y="0" width="542" height="783" viewBox="0 0 542 783" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                style="display: block;margin-left: auto;margin-right: auto;">
                <path d="M52.6,735H355c2.3,0,4.3,-2,4.3,-4.4V577.4c0,-2.4,1.9,-4.3,4.3,-4.3H470.2c2.4,0,4.3,-2,4.3,-4.4V124.3c0,-2.4,-1.9,-4.4,-4.3,-4.4h-103c-2.4,0,-4.4,-1.9,-4.4,-4.3V14.9c0,-2.4,-1.9,-4.3,-4.3,-4.3H199.9c-2.4,0,-4.4,1.9,-4.4,4.3l.9,100.7c0,2.4,-2,4.3,-4.4,4.3L52.6,119.8c-2.4,0,-4.3,2,-4.3,4.4V730.6c0,2.4,1.9,4.4,4.3,4.4Z" class="layout" />
                <path d="M100.2,719.7H68c-2.4,0,-4.4,-1.9,-4.4,-4.3V683.1c0,-2.4,2,-4.3,4.4,-4.3h32.2c2.4,0,4.4,1.9,4.4,4.3v32.3c0,2.4,-2,4.3,-4.4,4.3Z" class="booth-box s2" />
                <path d="M245.6,597.5H213.4c-2.4,0,-4.3,-2,-4.3,-4.4V560.9c0,-2.4,1.9,-4.4,4.3,-4.4h32.2c2.4,0,4.4,2,4.4,4.4v32.2c0,2.4,-2,4.4,-4.4,4.4Z" class="booth-box s4" />
                <path d="M457.2,460.9H424.9c-2.4,0,-4.3,-1.9,-4.3,-4.3V424.3c0,-2.4,1.9,-4.3,4.3,-4.3h32.3c2.4,0,4.3,1.9,4.3,4.3v32.3c0,2.4,-1.9,4.3,-4.3,4.3Z" class="booth-box s11" />
                <path d="M457.2,284.9H425c-2.4,0,-4.4,-1.9,-4.4,-4.3V248.3c0,-2.4,2,-4.3,4.4,-4.3h32.2c2.4,0,4.4,1.9,4.4,4.3v32.3c0,2.4,-2,4.3,-4.4,4.3Z" class="booth-box s10" />
                <path d="M342.5,118.5H310.2c-2.4,0,-4.3,-1.9,-4.3,-4.3V81.9c0,-2.4,1.9,-4.3,4.3,-4.3h32.3c2.4,0,4.3,1.9,4.3,4.3v32.3c0,2.4,-1.9,4.3,-4.3,4.3Z" class="booth-box s9" />
                <path d="M251.1,118.2H218.9c-2.4,0,-4.4,-1.9,-4.4,-4.3V81.6c0,-2.4,2,-4.3,4.4,-4.3h32.2c2.4,0,4.3,1.9,4.3,4.3v32.3c0,2.4,-1.9,4.3,-4.3,4.3Z" class="booth-box s8" />
                <path d="M185.7,597.6H153.5c-2.4,0,-4.4,-1.9,-4.4,-4.3V561c0,-2.4,2,-4.3,4.4,-4.3h32.2c2.4,0,4.4,1.9,4.4,4.3v32.3c0,2.4,-2,4.3,-4.4,4.3Z" class="booth-box s3" />
                <path d="M101.7,378.5H69.4c-2.4,0,-4.3,-1.9,-4.3,-4.3V341.9c0,-2.4,1.9,-4.3,4.3,-4.3h32.3c2.4,0,4.3,1.9,4.3,4.3v32.3c0,2.4,-1.9,4.3,-4.3,4.3Z" class="booth-box s5" />
                <path d="M101.5,320.5H69.2c-2.4,0,-4.3,-2,-4.3,-4.4V283.9c0,-2.4,1.9,-4.4,4.3,-4.4h32.3c2.3,0,4.3,2,4.3,4.4v32.2c0,2.4,-2,4.4,-4.3,4.4Z" class="booth-box s6" />
                <path d="M101.2,264.4H69c-2.4,0,-4.4,-1.9,-4.4,-4.3V227.8c0,-2.3,2,-4.3,4.4,-4.3h32.2c2.4,0,4.4,2,4.4,4.3v32.3c0,2.4,-2,4.3,-4.4,4.3Z" class="booth-box s7" />
                <path d="M185.1,718.8H152.9c-2.4,0,-4.4,-1.9,-4.4,-4.3V682.2c0,-2.4,2,-4.3,4.4,-4.3h32.2c2.4,0,4.4,1.9,4.4,4.3v32.3c0,2.4,-2,4.3,-4.4,4.3Z" class="booth-box s1" />
                <path d="M342.5,718.4H310.2c-2.4,0,-4.3,-1.9,-4.3,-4.3V681.8c0,-2.4,1.9,-4.3,4.3,-4.3h32.3c2.4,0,4.3,1.9,4.3,4.3v32.3c0,2.4,-1.9,4.3,-4.3,4.3Z" class="booth-box s14" />
                <path d="M342.5,657.4H310.2c-2.4,0,-4.3,-2,-4.3,-4.3V620.8c0,-2.4,1.9,-4.3,4.3,-4.3h32.3c2.4,0,4.3,1.9,4.3,4.3v32.3c0,2.3,-1.9,4.3,-4.3,4.3Z" class="booth-box s13" />
                <path d="M342.5,597.2H310.2c-2.4,0,-4.3,-1.9,-4.3,-4.3V560.6c0,-2.4,1.9,-4.3,4.3,-4.3h32.3c2.4,0,4.3,1.9,4.3,4.3v32.3c0,2.4,-1.9,4.3,-4.3,4.3Z" class="booth-box s12" />
                <text x="76" y="705" class="booth-text silver s2">S2</text>
                <path d="M353.4,415.9H215.8c-2.4,0,-4.4,-1.9,-4.4,-4.3V274.7c0,-2.4,2,-4.4,4.4,-4.4H353.4c2.4,0,4.3,2,4.3,4.4V411.6c0,2.4,-1.9,4.3,-4.3,4.3Z" class="booth-box general" />
                <path d="M130.4,641.8H66.7c-2.4,0,-4.3,-2,-4.3,-4.4V573.8c0,-2.4,1.9,-4.3,4.3,-4.3h63.7c2.4,0,4.3,1.9,4.3,4.3v63.6c0,2.4,-1.9,4.4,-4.3,4.4Z" class="booth-box z1" />
                <path d="M132,471.5H68.3c-2.4,0,-4.3,-1.9,-4.3,-4.3V403.5c0,-2.3,1.9,-4.3,4.3,-4.3H132c2.4,0,4.3,2,4.3,4.3v63.7c0,2.4,-1.9,4.3,-4.3,4.3Z" class="booth-box z2" />
                <path d="M131.4,202.3H67.7c-2.4,0,-4.3,-1.9,-4.3,-4.3V134.3c0,-2.4,1.9,-4.3,4.3,-4.3h63.7c2.4,0,4.3,1.9,4.3,4.3V198c0,2.4,-1.9,4.3,-4.3,4.3Z" class="booth-box z3" />
                <text x="275" y="353" class="booth-text general">G</text>
                <text x="314" y="705" dx="0,-0.2,0" class="booth-text silver s14">S14</text>
                <text x="314" y="641" dx="0,-0.2,0" class="booth-text silver s13">S13</text>
                <text x="428" y="447" dx="0,-0.2,-0.2" class="booth-text silver s11">S11</text>
                <text x="428" y="270" dx="0,-0.2,0" class="booth-text silver s10">S10</text>
                <text x="318" y="104" dx="0,-0.1" class="booth-text silver s9">S9</text>
                <text x="226" y="104" class="booth-text silver s8">S8</text>
                <text x="76" y="249" class="booth-text silver s7">S7</text>
                <text x="89" y="170" class="booth-text gold z3">Z3</text>
                <text x="89" y="440" class="booth-text gold z2">Z2</text>
                <text x="89" y="609" class="booth-text gold z1">Z1</text>
                <text x="76" y="304" class="booth-text silver s6">S6</text>
                <text x="76" y="363" class="booth-text silver s5">S5</text>
                <text x="160" y="705" dx="0,-0.2" class="booth-text silver s1">S1</text>
                <text x="161" y="582" class="booth-text silver s3">S3</text>
                <text x="221" y="582" class="booth-text silver s4">S4</text>
                <text x="140" y="766" dx="0,0,0,0,0,0,0,-0.8,-0.4,0,0,0" class="outline-text">AKREDITACIJE</text>
                <text x="394" y="646" dx="0,0,0,0,0,0,0,0,0,0,0,0,0,-0.2,0,0" class="outline-text">SREBRNI SPONZORI</text>
                <text x="394" y="670" dx="0,0,0,-0.8,0,0,0,0,0,0,0,0,-0.2,0,0" class="outline-text">ZLATNI SPONZORI</text>
                <text x="394" y="694" dx="0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,-0.2,0" class="outline-text">GENERALNI SPONZOR</text>
                <text transform="matrix(0, -1, 1, 0, 29, 671)" dx="0,-0.7,0,0,0,0,0,0,0,0,-0.1,-0.1,-0.2,-0.3,0" class="outline-text">VANJSKI PROSTOR</text>
                <text x="394" y="609" class="legend">Legenda</text>
                <text x="368" y="646" class="legend-text">S</text>
                <text x="368" y="670" class="legend-text">Z</text>
                <text x="368" y="694" class="legend-text">G</text>
                <path d="M280.8,759.3c0,9.6,-7.7,17.4,-17.3,17.4c-9.6,0,-17.4,-7.8,-17.4,-17.4c0,-9.5,7.8,-17.3,17.4,-17.3c9.6,0,17.3,7.8,17.3,17.3Z" class="dot" />
                <path d="M520,506c0,9.6,-7.8,17.4,-17.4,17.4c-9.5,0,-17.3,-7.8,-17.3,-17.4c0,-9.5,7.8,-17.3,17.3,-17.3c9.6,0,17.4,7.8,17.4,17.3Z" class="dot" />
                <path d="M42.8,523.4c0,9.6,-7.7,17.3,-17.3,17.3C15.9,540.7,8.1,533,8.1,523.4C8.1,513.8,15.9,506,25.5,506c9.6,0,17.3,7.8,17.3,17.4Z" class="dot" />
                <text x="314" y="583" dx="0,-0.2,0" class="booth-text silver s12">S12</text>
                <text transform="matrix(0, -1, 1, 0, 507, 481)" class="s1_1">DVORANA</text>
            </svg>
            <div class="map-details">
                <img v-on:click="previousNextBooth(false)" src="../../assets/app-icons/event-details/next.svg" alt="Prethodni prostor" />
                <div>
                    <span class="selected-name">{{selectedName}}</span>
                    <a v-if="selectedUrl.length" v-bind:href="selectedUrl" target="_blank" rel="noreferrer">
                        <img class="link-icon" src="../../assets/app-icons/map/link.png" />
                    </a>
                </div>
                <img v-on:click="previousNextBooth(true)" src="../../assets/app-icons/event-details/next.svg" alt="Idući prostor" />
            </div>
        </div>
        <div class="list-map">
            <div class="list-map-title">GENERALNI SPONZOR</div>
            <div v-for="sponsor in sponsors.filter(sponsor => sponsor.boothLocation && sponsor.boothLocation === 'general')" v-bind:key="sponsor.id" class="list-map-sponsor">
                <a v-if="sponsor.websiteUrl" v-bind:href="sponsor.websiteUrl" target="_blank" rel="noreferrer">
                    <span>{{sponsor.name}}</span>
                    <img v-bind:src="getLogo(sponsor.name)" v-bind:alt="`${sponsor.name} logo`" v-bind:class="getSponsorNameNormalized(sponsor.name)" />
                </a>
                <a v-else>
                    <span>{{sponsor.name}}</span>
                    <img v-bind:src="getLogo(sponsor.name)" v-bind:alt="`${sponsor.name} logo`" v-bind:class="getSponsorNameNormalized(sponsor.name)" />
                </a>
            </div>
            <div class="list-map-title">ZLATNI SPONZORI</div>
            <div v-for="sponsor in sponsors.filter(sponsor => sponsor.boothLocation && sponsor.boothLocation.startsWith('z')).sort((firstSponsor, secondSponsor) => firstSponsor.name < secondSponsor.name ? -1 : 1)" v-bind:key="sponsor.id" class="list-map-sponsor">
                <a v-if="sponsor.websiteUrl" v-bind:href="sponsor.websiteUrl" target="_blank" rel="noreferrer">
                    <span>{{sponsor.name}}</span>
                    <img v-bind:src="getLogo(sponsor.name)" v-bind:alt="`${sponsor.name} logo`" v-bind:class="getSponsorNameNormalized(sponsor.name)" />
                </a>
                <a v-else>
                    <span>{{sponsor.name}}</span>
                    <img v-bind:src="getLogo(sponsor.name)" v-bind:alt="`${sponsor.name} logo`" v-bind:class="getSponsorNameNormalized(sponsor.name)" />
                </a>
            </div>
            <div class="list-map-title">SREBRNI SPONZORI</div>
            <div v-for="sponsor in sponsors.filter(sponsor => sponsor.boothLocation && sponsor.boothLocation.startsWith('s')).sort((firstSponsor, secondSponsor) => firstSponsor.name < secondSponsor.name ? -1 : 1)" v-bind:key="sponsor.id" class="list-map-sponsor">
                <a v-if="sponsor.websiteUrl" v-bind:href="sponsor.websiteUrl" target="_blank" rel="noreferrer">
                    <span>{{sponsor.name === 'Bundesdruckerei' ? 'Maurer Electronics' : sponsor.name}}</span>
                    <img v-bind:src="getLogo(sponsor.name)" v-bind:alt="`${sponsor.name} logo`" v-bind:class="getSponsorNameNormalized(sponsor.name)" />
                </a>
                <a v-else>
                    <span>{{sponsor.name}}</span>
                    <img v-bind:src="getLogo(sponsor.name)" v-bind:alt="`${sponsor.name} logo`" v-bind:class="getSponsorNameNormalized(sponsor.name)" />
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Map',
        data() {
            return {
                sponsors: [],
                selectedName: '',
                selectedUrl: ''
            }
        },
        methods: {
            switchMode: function(modeIndex) {
                let mapMenuDivs = document.querySelectorAll('.map-menu div');
                for(let mapMenuDiv of mapMenuDivs)
                    mapMenuDiv.classList.remove('active');

                mapMenuDivs[modeIndex].classList.add('active');

                let realMap = document.querySelector('#map-container .real-map');
                let listMap = document.querySelector('#map-container .list-map');
                if(modeIndex === 0)
                {
                    listMap.style.display = 'none';
                    realMap.style.display = 'block';
                }
                else
                {
                    realMap.style.display = 'none';
                    listMap.style.display = 'block';
                }
            },
            updateSelectedSponsor: function(sponsorIndex) {
                let selectedSponsor = this.sponsors[sponsorIndex];
                if(selectedSponsor.name === 'Bundesdruckerei')
                    this.selectedName = 'Maurer Electronics';
                else
                    this.selectedName = selectedSponsor.name;
                
                if(selectedSponsor.websiteUrl)
                    this.selectedUrl = selectedSponsor.websiteUrl;
                else
                    this.selectedUrl = '';
            },
            previousNextBooth: function(isNext) {
                let currentBooth = document.querySelector('.booth-box.active');
                if(!currentBooth)
                    return;
                    
                let currentBoothClasses = [...currentBooth.classList];
                let boothLabel = currentBoothClasses.filter(cl => cl !== 'booth-box' && cl !== 'active')[0];

                let sponsorIndex = this.sponsors.findIndex(sponsor => sponsor.boothLocation && sponsor.boothLocation === boothLabel);
                if(sponsorIndex !== -1)
                {
                    if(isNext)
                    {
                        if(sponsorIndex === this.sponsors.length - 1)
                            sponsorIndex = 0;
                        else
                            sponsorIndex = sponsorIndex + 1;
                    }
                    else
                    {
                        if(sponsorIndex === 0)
                            sponsorIndex = this.sponsors.length - 1;
                        else
                            sponsorIndex = sponsorIndex - 1;
                    }

                    this.updateSelectedSponsor(sponsorIndex);
                    let mapBoxes = document.getElementsByClassName('booth-box');
                    for(let box of mapBoxes)
                    {
                        box.classList.remove('active');
                        if(box.classList.contains(this.sponsors[sponsorIndex].boothLocation))
                            box.classList.add('active');
                    }
                }
            },
            getLogo: function (sponsorName) {
                return require(`../../assets/companies/logos/${this.getSponsorNameNormalized(sponsorName)}.png`);
            },
            getSponsorNameNormalized: function (sponsorName) {
                if(sponsorName === 'Maurer Electronics')
                    sponsorName = 'Bundesdruckerei';

                return sponsorName.replace(/\s/g, '').toLowerCase();
            }
        },
        mounted() {
            let allMapBoxes = document.getElementsByClassName('booth-box');
            let allMapTexts = document.getElementsByClassName('booth-text');
            let $vm = this;

            this.$axios.get(`${this.$API_URL}/companies/all-sponsors`).then(response => {
                this.sponsors = response.data.filter(sponsor => 
                    sponsor.sponsorCategory === 'General' || 
                    sponsor.sponsorCategory === 'Gold' || 
                    sponsor.sponsorCategory === 'Silver')
                    .sort((firstSponsor, secondSponsor) => {
                        if(!firstSponsor.boothLocation || !secondSponsor.boothLocation)
                            return 1;
                        
                        if(firstSponsor.boothLocation.charAt(0) < secondSponsor.boothLocation.charAt(0))
                            return -1;
                        else if(firstSponsor.boothLocation.charAt(0) > secondSponsor.boothLocation.charAt(0))
                            return 1;

                        return parseInt(firstSponsor.boothLocation.substr(1)) < parseInt(secondSponsor.boothLocation.substr(1)) ? -1 : 1;
                    }); 

                let sponsorNameFromRoute = this.$route.params.sponsorName;
                if(sponsorNameFromRoute)
                {
                    let sponsorToSelectIndex = this.sponsors.findIndex(sponsor => sponsor.name === sponsorNameFromRoute);

                    this.updateSelectedSponsor(sponsorToSelectIndex);

                    let boxToHighlight = document.querySelector(`.booth-box.${this.sponsors[sponsorToSelectIndex].boothLocation}`);

                    for(let box of allMapBoxes)
                        box.classList.remove('active');
                    boxToHighlight.classList.add('active');
                }
                else
                {
                    let generalSponsor = this.sponsors.filter(sponsor => sponsor.boothLocation && sponsor.boothLocation === 'general')[0];
                    
                    if(generalSponsor)
                    {
                        this.selectedName = generalSponsor.name;
                        if(generalSponsor.websiteUrl)
                            this.selectedUrl = generalSponsor.websiteUrl;
                        else
                            this.selectedUrl = '';

                        let boxToHighlight = document.querySelector(`.booth-box.${generalSponsor.boothLocation}`);

                        for(let box of allMapBoxes)
                            box.classList.remove('active');
                        boxToHighlight.classList.add('active');
                    }
                }

                for(let mapBox of allMapBoxes)
                    mapBox.addEventListener('click', function() {
                        for(let box of allMapBoxes)
                            box.classList.remove('active');
                        mapBox.classList.add('active');
    
                        let currentMapBoxClasses = [...mapBox.classList];
                        let boothClass = currentMapBoxClasses.filter(cl => cl !== 'booth-box' && cl !== 'active')[0];  
                        
                        let selectedSponsorIndex = $vm.sponsors.findIndex(sponsor => sponsor.boothLocation && sponsor.boothLocation === boothClass);
                        if(selectedSponsorIndex !== -1)
                            $vm.updateSelectedSponsor(selectedSponsorIndex);
                    });

                for(let mapText of allMapTexts)
                    mapText.addEventListener('click', function() {
                        for(let box of allMapBoxes)
                            box.classList.remove('active');

                            let currentMapTextClasses = [...mapText.classList];
                            let boothClass = currentMapTextClasses.filter(cl => cl !== 'booth-text' && cl !== 'silver' && cl !== 'gold')[0];  
                            
                            let selectedBoxIndex = [...allMapBoxes].findIndex(mb => mb.classList.contains(boothClass));                 
                            if(selectedBoxIndex !== -1)
                                allMapBoxes[selectedBoxIndex].classList.add('active');

                            let selectedSponsorIndex = $vm.sponsors.findIndex(sponsor => sponsor.boothLocation && sponsor.boothLocation === boothClass);
                            if(selectedSponsorIndex !== -1)
                                $vm.updateSelectedSponsor(selectedSponsorIndex);
                    });
            });
        }
    }
</script>

<style scoped>
    #map-container {
        padding: 0 10px;
    }

    .map-title {
        font-size: 22px;
        font-weight: 800;
        line-height: 26px;
        margin: 30px 30px 15px 30px;
    }

    .map-menu {
        margin-left: 30px;
        display: flex;
        margin-bottom: 10px;
    }

    .map-menu div {
        opacity: 0.55;
        display: flex;
        align-items: center;
    }

    .map-menu div:hover {
        cursor: pointer;
    }

    .map-menu div:first-of-type {
        margin-right: 20px;
    }

    .map-menu div.active {
        opacity: 1;
    }

    .map-menu img {
        margin-right: 8px;
    }

    .map-menu span {
        font-size: 12px;
        font-weight: 800;
    }

    .real-map svg {
        margin-left: auto;
        margin-right: auto;
        width: 100%;
        height: 65vh;
    }

    .outline-text {
        font-size: 15.28px;
        fill: #193B44;
        font-weight: 700;
    }

    .booth-text.general {
        font-size: 30.56px;
        fill: #FFFFFF;
    }

    .booth-text.silver,
    .booth-text.gold {
        font-size: 15.28px;
        fill: #FFFFFF;
        font-weight: 700;
    }

    .legend {
        font-size: 30.56px;
        fill: #5CC4BC;
    }

    .legend-text{
        font-size: 15.28px;
        fill: #193B44;
    }

    .layout {
        fill: lightgray;
        opacity: 0.2;
    }

    .booth-box,
    .dot {
        fill: #5CC4BC;
    }

    .booth-box.active {
        fill: #2C373F;
    }

    .booth-box:hover,
    .booth-text:hover {
        cursor: pointer;
    }

    .map-details {
        background-color: #2C373F;
        position: fixed;
        bottom: 62px;
        left: 0;
        width: 100%;
        height: 40px;
        color: white;
        display: flex;
        align-items: center;
    }

    .map-details img {
        filter: invert(100%);
    }

    .map-details img:hover {
        cursor: pointer;
    }

    .map-details img:first-of-type {
        transform: rotate(180deg);
        margin-left: 20px;
        margin-right: 10px;
    }

    .map-details img:last-of-type {
        margin-right: 20px;
    }

    .map-details div {
        margin-left: auto;
        margin-right: auto;
        display: flex;
        align-items: center;
    }

    .map-details img.link-icon {
        filter: invert(78%) sepia(9%) saturate(3087%) hue-rotate(121deg) brightness(92%) contrast(83%);
        height: 20px;
    }

    .list-map {
        display: none;
        padding-left: 20px;
    }

    .list-map-title {
        font-size: 16px;
        letter-spacing: 0.5px;
        line-height: 20px;
        color: #30cec1;
    }

    .list-map-title:first-of-type {
        margin-top: 30px;
    }

    .list-map-sponsor {
        height: 60px;
        display: flex;
        align-items: center;
    }

    .list-map-sponsor span {
        font-size: 18px;
        line-height: 21px;
        color: black;
    }

    .list-map-sponsor img {
        width: 80px;
        height: auto;
        margin-left: auto;
        margin-right: 5px;
    }

    .list-map-sponsor a {
        display: inline-block;
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
    }

    .list-map-sponsor .rimacautomobili {
        transform: scale(1.4);
    }

    .list-map-sponsor .ericssonnikolatesla {
        transform: scale(0.5);
    }

    .list-map-sponsor .atos {
        transform: scale(0.7);
    }

    .list-map-sponsor .bundesdruckerei {
        transform: scale(0.6);
    }

    .list-map-sponsor .dobartek\.hr {
        transform: scale(1.1);
    }
</style>